module.exports = "/assets/images/0d4ff451dd3c08a4a74d2224afa1c799.svg";


//////////////////
// WEBPACK FOOTER
// ./~/@3plearning/3p-teacheradmin-assets/assets/icons/icon_up.svg
// module id = goH6
// module chunks = 0